import React from 'react';
import { Typography } from '@mui/material';
import MainRecentArticleGridLayout from '@/components/blocks/ArticleList/MainRecentArticleGridLayout';
import { IPostFragment } from '@orgnc/core/generated/graphql-operations';

interface LatestPostProps {
  post: IPostFragment;
}
const LatestPost: React.FC<LatestPostProps> = ({ post }) => {
  return (
    <>
      <Typography
        component="div"
        id="buyingGuideSpotlight"
        sx={{ py: 3 }}
        variant="h4"
      >
        Buying Guide Spotlight
      </Typography>
      <MainRecentArticleGridLayout posts={[post]} />
    </>
  );
};

export default LatestPost;
